import React, { useState, useRef, useEffect } from "react";
import "./CustomUserModal.scss";
import { NewUser, PictureNew } from "../../util/API/customers";
import CustomForm from "../UI/CustomForm/CustomForm";
import { createExternalAccounts } from "../../util/API/externalaccounts";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import CustomStepWizard from "../UI/CustomStepWizard/CustomStepWizard";
import { Box } from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import { CheckIfEmailExists } from "../../util/API/operator";
import {
  getCustomerTypes,
  getCustomerSubTypes,
} from "../../util/API/customers";

function CustomUserModal({
  open,
  handleClose,
  updateState,
  conditionalFields,
  onCreate,
}) {
  const [userImage, setUserImage] = useState("");
  const [userBase64, setUserBase64] = useState("");
  const [error, setError] = useState("");
  const [newUser, setNewUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
    userId: "",
  });
  const [formDataCollected, setFormDataCollected] = useState({ });
  const [currentStep, setCurrentStep] = useState(0);
  const [isMerchant, setIsMerchant] = useState(false); // State to track if merchant fields are shown

  const [customerTypes, setCustomerTypes] = useState([]);
  const [customerSubTypes, setCustomerSubTypes] = useState([]);
  const [selectedCustomerType, setSelectedCustomerType] = useState("1");
  const [addBussinessToggleBit, setAddBussinessToggleBit] = useState(false);

  const formRef = useRef(null);
  const containerRef = useRef(null);

  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;
  const triggerFields = ["ismerchant"];
  const isOperator = sessionStorage.getItem("isOperator");
  const parentuserid = sessionStorage.getItem("parentuserid");

  const handlePrevious = () => {
    setCurrentStep((prevStep) => Math.max(prevStep - 1, 0));
  };
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      let reader = new FileReader();

      reader.onload = (e) => {
        setUserImage(e.target.result);
        setUserBase64(e.target.result);
      };

      reader.readAsDataURL(img);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const onSubmit = async (data, formData) => {
    setLoading(true);
    setNewUser("");
    setError("");
    // console.log("requestData===============",data);

    const requiredFields = formData
      // .filter((field) => field.validation?.required)
      .filter((field) => {
        if (!field.validation?.required) return false;
  
        // Handle conditional required field "abc"
        if (field.name === "peppersons" && data.politicallyexposed !== "1") {
          return false; // skip this required field
        }
  
        return true;
      })
      .map((field) => field.name);


    const missingFields = requiredFields.filter(
      (fieldName) =>
        !data[fieldName] || data[fieldName].toString().trim() === "" || data[fieldName].toString().trim() === "na"
    );

    if (missingFields.length > 0) {
      return;
    }

    // console.log(data);

    // let phoneNo = data.areaCode.value + data.phoneno;
    let phoneNo = data.phoneno;

    let requestData = { ...data }; // Shallow copy

    requestData.telephoneno = data.phoneno;
    console.log("data.politicallyexposed================",data.politicallyexposed);
    if (data.politicallyexposed == "0") {
      requestData.peppersons = "0";
    }

    // console.log(phoneNo);
    // console.log("requestData2222===============",requestData);

    if (data.defaultLogin === "2") {
      const sanitizedAreaCode = data.areaCode.value.replace("+", "");
      const sanitizedPhone = phoneNo.replace("+", "");
      const fullPhoneNumber = `${sanitizedAreaCode}${sanitizedPhone}`;

      requestData.email = `${fullPhoneNumber}@4pay.ph`;
      requestData.noEmail = 1;

      // console.log(requestData.email);
      // console.log(sanitizedPhone);
    } else {
      requestData.noEmail = 0;

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (data?.email === "" || !emailRegex.test(data.email)) {
        setAlert({
          showAlert: true,
          message: "Enter a valid email address",
          severity: "error",
          header: "Error",
        });
        return;
      }
    }

    const specialCharRegex = /[^a-zA-Z0-9\s]/; // Matches any non-alphanumeric (excluding spaces)
    const phoneRegex = /^\d{10}$/;

    const errors = [];

    if (specialCharRegex.test(requestData.pob)) {
      errors.push("Place of Birth should not contain special characters.");
    }
  
    if (specialCharRegex.test(requestData.zip)) {
      errors.push("ZIP Code should not contain special characters.");
    }
  
    if (!phoneRegex.test(requestData.phoneno)) {
      errors.push("Phone number must contain 10 digits.");
    }

    if (errors.length > 0) {
      console.error("Validation Errors:", errors);
      // Optionally show error to user
      setAlert({
        showAlert: true,
        message: errors.join("\n"),
        severity: "error",
        header: "Validation Error",
      });
      return; // Stop form submission
    }


    if (requestData?.dob) {
      requestData.dob = formatDate(requestData.dob);
    }

    if (
      new Date().getFullYear() - parseInt(requestData.dob.split("-")[0]) <
      18
    ) {
      setAlert({
        showAlert: true,
        message:
          "Thank you for your interest in opening an account with us. However, your date of birth indicates that you are unable to hold an account as an individual. But you are able to hold an account with a parent or guardian.",
        severity: "error",
        header: "Error",
      });
      return;
    }

    // if (requestData?.phoneno) {
    //   requestData.phoneno = `${data?.areaCode?.value}${phoneNo}`;
    // }
    // console.log("requestDataUpdated===============",requestData);
    let extendedFields = {};

    formData.forEach((item) => {
      console.log("formData.forEach================",item);

      if (item.core === 0 && requestData.hasOwnProperty(item.name)) {
        extendedFields[item.name] = requestData[item.name];
        delete requestData[item.name];
      }
    });

    requestData.extendedFields = JSON.stringify(extendedFields);
    requestData.telephonenocountrycode = data?.areaCode?.key;
    requestData.contactphonenocountrycode = data?.areaCode?.key;
    console.log("requestDataUpdated===============",requestData);
    try {
      const emailExists = await CheckIfEmailExists(requestData);

      if (emailExists.callStatus == 0) {
        setAlert({
          showAlert: true,
          message: `${emailExists.payload.data.header.msg}`,
          severity: "error",
          header: "Error",
        });
        throw new Error(`${emailExists.payload.data.header.msg}`);
      }

      const response = await NewUser(requestData, agent["User"].id, isMerchant);

      let callStatus = response.data.payload.callStatus;
      let userId;
      if (callStatus == 1) {
        userId = response.data.payload.userid;
        setNewUser("User created successfully");
        // updateState();

        setAlert({
          showAlert: true,
          message: "User Created Successfully",
          severity: "success",
          header: "Success",
          userId: userId,
        });

        setFormDataCollected({ }); 

        updateState(); 

        if (userBase64) {
          let newPicture = await PictureNew(userId, userBase64);
        }

        try {
          const externalAccountCreation = await createExternalAccounts(
            requestData,
            userId,
            agent["User"].id,
            isOperator,
            parentuserid
          );

          let callStatus = externalAccountCreation.data.payload.callStatus;
          if (callStatus != 1) {
            setError(`${externalAccountCreation.data.payload.msg}`);
          }
        } catch (error) {
          
        }
      } else {
        setError(`${response.data.payload.msg}`);
        throw new Error(`${response.data.payload.msg}`);
      }
    } catch (error) {
      console.error(error);
      setError("An error occurred while creating the user.");
      setAlert({
        showAlert: true,
        message: `${error}`,
        severity: "error",
        header: "error",
      });
    }

    setLoading(false);
  };

  const closeModal = () => {
    if (formRef.current) {
      formRef.current.resetForm();
    }
    handleClose();
  };

  const [steps, setSteps] = useState([
    { label: "SelectUser", index: 0 },
    { label: "Personal", index: 1 },
    { label: "Contact", index: 2 },
  ]);

  // const steps = [
  //   { label: "Personal", index: 0 },
  //   { label: "Contact", index: 1 },
  //   // { label: "Employment", index: 2 },
  //   ...(isMerchant ? [{ label: "Business", index: 2 }] : []),
  // ];

  const conditionalGroups = {
    "Business Information": (watch) =>
      watch("ismerchant") === true || watch("ismerchant") === "true",
  };

  // console.log(isMerchant);

  // console.log(steps.length);

  const handleStepChange = (stepIndex) => {
    setCurrentStep(stepIndex);
    const panel = containerRef.current.children[stepIndex];
    if (panel) {
      panel.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    setFormDataCollected({ });
    if(open==true) {
      fetchCustomerType();
    }
  }, [open]);

  const handleIsMerchant = (stepData) => {
    // console.log(stepData);
    if (stepData?.ismerchant === true || stepData?.ismerchant === "true") {
      setIsMerchant(true);
    } else {
      setIsMerchant(false);
    }
  };

  const fetchCustomerSubType = async () => {
    try {
      const res = await getCustomerSubTypes(202, selectedCustomerType);
      // console.log(
      //   "fetchCustomerSubTypeRes---------------------",
      //   res?.data?.body?.record
      // );

      // Handle both cases: array and single object
      const record = res?.data?.body?.record;

      // Check if record is an array or a single object
      const transformedSubCustomerType = Array.isArray(record)
        ? record.map((item) => ({
            key: item.usersubtype.subtypeID,
            value: item.usersubtype.subtypeID,
            label: item.usersubtype.name,
          }))
        : record?.usersubtype // If single object
        ? [
            {
              key: record.usersubtype.subtypeID,
              value: record.usersubtype.subtypeID,
              label: record.usersubtype.name,
            },
          ]
        : [
            {
              key: "not-available",
              value: "not-available",
              label: "Not Available",
            },
          ];

      // Set the transformed data to state
      setCustomerSubTypes(transformedSubCustomerType);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const fetchCustomerType = async () => {
    try {
      const res = await getCustomerTypes(201);
      const transformedCustomerType =
        (await res?.data?.body?.record?.length) > 0
          ? res?.data?.body?.record?.map((item) => ({
              key: item.usertype.typeID,
              value: item.usertype.typeID,
              label: item.usertype.name,
            }))
          : [
              {
                key: "not-available",
                value: "not-available",
                label: "Not Available",
              },
            ];
      // console.log("transformedCustomerType------------------",transformedCustomerType)
      setCustomerTypes(transformedCustomerType);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  useEffect(()=> {
    if(selectedCustomerType) {
      fetchCustomerSubType();
    }
  },[selectedCustomerType])

  const handleFieldClick = (field) => {
    // console.log("Field clicked in group:", field)
    if(field.formgroup === "Personal Information") {
      setCurrentStep(1);
    } else if(field.formgroup === "Contact Information") {
      setCurrentStep(2);
    } else if(field.formgroup === "Business Information") {
      setCurrentStep(3);
    }
  }

  const handleAddBussinessToggleBit = () => {
    setAddBussinessToggleBit((prev) => {
      if (!prev) {
        setSteps((prevSteps) => [
          ...prevSteps,
          { label: "Business", index: prevSteps.length },
        ]);
      } else {
        setSteps((prevSteps) => prevSteps.filter((step) => step.label !== "Business"));
      }
      return !prev;
    });
  }

  return (
    <BaseDrawer
      open={open}
      handleClose={closeModal}
      height="90vh"
      title={"Add New User"}
    >
      <Box
        className="centered-content"
        sx={{
          overflow: "auto", 
          maxHeight: "90vh", 
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute", 
              left: "50%",
              transform: "translateX(-50%)", 
              width: "220px", 
              height: "100px",
              zIndex: "1",
              marginTop: "20px",
            }}
          >
            <CustomStepWizard
              className="custom-step-wizard"
              steps={steps}
              current={currentStep}
              onStepChange={handleStepChange}
            />
          </Box>
        </Box>

        <Box sx={{ marginBottom: "60px" }} />

        <Box
          className="customer-profile-container-modal"
          sx={{
            overflowY: "auto", 
            maxHeight: "calc(90vh - 60px)", 
          }}
        >
          <Box
            className="customer-details"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "row",
              whiteSpace: "nowrap",
              overflowX: "auto",
              zIndex: "1",
            }}
          >
            <CustomForm
              ref={formRef}
              // formName={"newuser"}
              formName={"onboarduser1"}
              formValues={formDataCollected}
              fieldRendererType="registration"
              conditionalFields={conditionalFields}
              useStep={true}
              onNext={handleIsMerchant}
              onPrevious={currentStep > 0 ? handlePrevious : null}
              onSubmit={onSubmit}
              buttonText={"Add User"}
              loadingButtonText={"Adding User..."}
              triggerFields={triggerFields}
              twoColumns={true}
              buttonInPanel={true}
              containerText={"Add New User"}
              isRegistration={true}
              conditionalGroups={conditionalGroups}
              customerTypes={customerTypes}
              customerSubTypes={customerSubTypes}
              setSelectedCustomerType={setSelectedCustomerType}
              onFieldClick={handleFieldClick}
              handleAddBussinessToggleBit={handleAddBussinessToggleBit}
            />
          </Box>
        </Box>
      </Box>
      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={(prevDetails) => {
          setAlert({ ...prevDetails, showAlert: false });
          if (alert.severity === "success") {
            handleClose();
            onCreate(alert.userId);
          }
        }}
        autoclose={alert.severity === "error" ? false : true}
      />
    </BaseDrawer>
  );
}

export default CustomUserModal;
